export enum ClaimCategory {
    PersonalWellBeing = 'Personal well being',
    Remuneration = 'Remuneration',
    Bullying = 'Bullying',
    WorkingCondition = 'Working conditions',
    Workload = 'Workload',
    IssuesWithColleagues = 'Issues with collagues',
}
